import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import { Delete } from "@mui/icons-material";

const DeleteDocumentDialog = ({ document, onSubmit }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleSubmit = async () => {
    setOpen(false);
    onSubmit();
  };

  const handleAbort = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleClickOpen}
        startIcon={<Delete />}
        color="error"
      >
        Löschen
      </Button>
      <Dialog
        open={open}
        onClose={handleAbort}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="delete-document-dialog"
      >
        <DialogTitle id="alert-dialog-title">Dokument löschen</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" component="div">
            Löschen des Dokumentes{" "}
            <span className="important-phrase">"{document.fileName}"</span>.
            Durch das Löschen wird sowohl das Dokument, als auch automatisch
            alle Seiten, die dieses Dokument verwenden unwiederruflich entfernt.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAbort}>Abbrechen</Button>
          <Button onClick={handleSubmit} autoFocus>
            Löschen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteDocumentDialog;
